import React from "react";
import { type ProductCardBase } from "types/product";
import { SanityRichText } from "@bared/ui";
import { type Content } from "@ts/sanity";
import {
  HeroProductFeature as BaseHeroProductFeature,
  HeroProductFeatureProps,
} from "@bared/ui";
import { Carousel, CarouselScrollbar, CarouselSection } from "@bared/ui";
import { ProductImage } from "@bared/ui";

export interface HeroProductFeatureSectionProps
  extends HeroProductFeatureProps {
  products: ProductCardBase[];
  content: Content;
  subContent?: Content;
  textAlignment?: "left" | "center";
  verticalAlignment?: "top" | "center";
}

export default function HeroProductFeature({
  content,
  subContent,
  products,
  textAlignment = "left",
  verticalAlignment = "center",
  ...props
}: HeroProductFeatureSectionProps) {
  return (
    <BaseHeroProductFeature {...props}>
      <div
        className={`flex h-full flex-col ${
          verticalAlignment === "center" ? "justify-center" : "justify-start"
        }`}
      >
        <div
          className={`mb-maxi ${
            textAlignment === "center" ? "text-center" : "text-left"
          }`}
        >
          <SanityRichText value={content} />
        </div>

        <Carousel
          ariaLabel="Featured products"
          slidesPerView={{ default: "1.5", md: "2", lg: "2" }}
          hideNativeScrollbar={true}
          className={`${products.length === 1 ? "justify-center" : ""} gap-1`}
        >
          {products.map((product, index) => (
            <CarouselSection key={product.handle} index={index}>
              <a href={`/products/${product.handle}`} className="block">
                <ProductImage
                  src={product.image}
                  sizes="100vw"
                  className="mb-pico bg-[#EDEAE8]"
                />
                <p className="text-center text-caption">
                  <span className="font-medium">{product.title}</span>{" "}
                  {product.subtitle}
                </p>
              </a>
            </CarouselSection>
          ))}
        </Carousel>

        <div className="md:hidden">
          <CarouselScrollbar />
        </div>

        {subContent && (
          <div className="mt-midi block text-center">
            <SanityRichText value={subContent} />
          </div>
        )}
      </div>
    </BaseHeroProductFeature>
  );
}
